(ns manage.content-configuration-page.predicate.expression
  (:require ["@mui/material/Stack$default" :as Stack]
            [clojure.set :refer [rename-keys]]
            [common.ui.store :as store]
            [common.util :as util]
            [manage.content-configuration-page.predicate.db
             :refer [value-type-modifier macro-type]]
            [manage.content-configuration-page.view.input :as view.input]
            [re-frame.core :as rf]))

(defn pull-predicate [pr]
  @(store/entity pr '[* {:context-source/_macro [*]}]))

(defmulti value-for-component
  (fn [_values component]
    component))

(defmethod value-for-component :tag-input
  [values _component]
  values)

(defmethod value-for-component :dropdown
  [values _component]
  (reduce (fn [result v]
            (cond-> result
              (string? v) (conj (hash-map :label v :value v))
              (map? v) (conj v))) [] values))

(defn value-options
  [pr component]
  (let [{user-values :predicate/value :predicate/keys [operator] :as predicate} (pull-predicate pr)
        schema-values @(rf/subscribe [:predicate/value-options predicate])]
    (or (not-empty schema-values)
        (when (and (contains? #{:in :not-in} operator)
                   (sequential? user-values))
          (value-for-component user-values component)))))

(defn- predicate-expression-value-dropdown
  [props pr]
  [view.input/dropdown-save-on-change
   (cond->
     (-> (view.input/props-entity pr :predicate/value)
         (assoc :key (pr-str pr :predicate/value (:control-props props)))
         (merge props)
         (assoc-in [:control-props :options] (value-options pr :dropdown))
         (assoc-in [:control-props :fast-options-conversion] true))

     (not (get-in props [:control-props :multi]))
     (assoc :validation/schema (or (:validation/schema props)
                                   [:string {:min 1 :error/message "Should select a value"}])))])

(rf/reg-sub :macro/type
  (fn [db [_ macro]]
    (macro-type db macro)))

(defmulti ^:private predicate-expression-value
  (fn [_props pr]
    @(rf/subscribe [:macro/type (pull-predicate pr)]))
  :default :string)

(defmethod predicate-expression-value :enum
  [props pr]
  [predicate-expression-value-dropdown props pr])

(defmethod predicate-expression-value :string
  [{control-props :control-props :as props} pr]
  (if (:multi control-props)
    [view.input/tags-input-save-on-change
     (update (merge (view.input/props-tag-input pr :predicate/value) props)
             :control-props merge {:options (value-options pr :tag-input)})]
    [view.input/input-save-on-blur
     (update (merge (view.input/props-entity pr :predicate/value) props)
             :control-props rename-keys {:disabled? :disabled})]))

(defmethod predicate-expression-value :timestamp
  [{:keys [value-path] :as props} pr]
  (let [value-path (conj value-path :timestamp)]
    [view.input/datetime-picker-save-on-change
     (merge (view.input/props-input-timestamp pr)
            (view.input/props-path pr :predicate/value value-path)
            props)]))

(defmethod predicate-expression-value :time
  [{:keys [value-path] :as props} pr]
  [view.input/time-picker-save-on-change
   (merge (view.input/props-input-time pr)
          (view.input/props-path pr :predicate/value value-path) props)])

(defmethod predicate-expression-value [:set :option]
  ;; used in context-source mapped targeting configuration e.g. weather
  [props pr]
  [predicate-expression-value-dropdown
   (-> props
       (assoc-in [:control-props :multi] true)) pr])

(defmethod predicate-expression-value :option
  ;; currently only used by split testing
  [props pr]
  [predicate-expression-value-dropdown props pr])

(defmethod predicate-expression-value :integer
  [{:keys [value-path] :as props} pr]
  [view.input/input-save-on-blur
   (update (merge (view.input/props-input-integer pr)
                  (view.input/props-path pr :predicate/value value-path util/str->int)
                  props)
           :control-props rename-keys {:disabled? :disabled})])

(defmethod predicate-expression-value :bool
  [_props _pr]
  "supported")

(defmulti predicate-expression
  (fn [_props pr]
    (value-type-modifier @(store/get-value pr :predicate/operator))))

(defmethod predicate-expression :list
  [props pr]
  [predicate-expression-value
   {:control-props (merge props {:multi true :clearable true})} pr])

(defmethod predicate-expression :range
  [props pr]
  [:> Stack {:direction "row" :spacing 1.5}
   [predicate-expression-value {:value-path [:start] :control-props props :form-field-props {:sx #js {:flex 1}}} pr]
   [predicate-expression-value {:value-path [:end] :control-props props :form-field-props {:sx #js {:flex 1}}} pr]])

(defmethod predicate-expression :nil
  [_props _pr])

(defmethod predicate-expression :default
  [props pr]
  [predicate-expression-value {:control-props props} pr])
